/** Round to 2 decimals (EUR). */
export const roundMoney = (n: number) => Math.round(n * 100) / 100

/** For fixed group discount: total TTC for base tariff only (reference × n − remise). */
export function tierTotalTTCFromDiscount(
  basePerPerson: number,
  n: number,
  discountValue: number
): number | null {
  if (basePerPerson <= 0 || n < 1 || Number.isNaN(discountValue)) return null
  return roundMoney(basePerPerson * n - discountValue)
}

/** Prix TTC par personne after discount (base tier only). */
export function tierPricePerPersonFromDiscount(
  basePerPerson: number,
  n: number,
  discountValue: number
): number | null {
  const total = tierTotalTTCFromDiscount(basePerPerson, n, discountValue)
  if (total == null) return null
  return roundMoney(total / n)
}

export function discountFromTierTotal(
  basePerPerson: number,
  n: number,
  tierTotalTTC: number
): number {
  return roundMoney(Math.max(0, basePerPerson * n - tierTotalTTC))
}
